import React, { useRef } from 'react';

import { Segment } from 'semantic-ui-react';

import Chart from "react-apexcharts";
import { useTranslation } from 'react-i18next';
import { unitFormat } from '../../helpers/money';
import useUser from '../Shared/UserProvider/useUser';
import { customTooltip } from './apexChartUtils';
import { useMutation, useQuery } from '@tanstack/react-query';
import { requestDownloadMetrics } from '../../services/Metrics/Metrics.service';
import { saveFile } from '../../services/File/File.service';
import { ultyToast } from '../Shared/UltyToast/UltyToast';
import { delay } from 'lodash';


const HourChart = ({ data, dateRange, merchantId, brands, platformIds }) => {
    const [t] = useTranslation();
    const { user } = useUser();

    const chartRef = useRef(null);

   

    const downloadHourlyData = useMutation({
        mutationFn: async () => {
           return await requestDownloadMetrics(dateRange, merchantId, brands, platformIds, 'hourly-pos');
        },

        onMutate:() => {
            chartRef.current.chart?.updateOptions(computeChartOptions(false), false, true);
        },

        onSuccess: async ({taskId}) => {
            if(taskId){
                ultyToast({ type: 'success', title: t('global.export.scheduled_export_will_be_ready') })
            }
        },
        onSettled:() => {
            chartRef.current.chart?.updateOptions(computeChartOptions(true), false, true);
        }
    });

     const computeChartOptions = (addCustomIcon) => (
        {
            dataLabels: {
                            enabled: false
            },
            chart: {
                ...(addCustomIcon ? {
                    toolbar: {
                        tools: {
                            customIcons: [{
                                icon: `<i class="icons" style="margin-left: 0.5rem" }>
                                            <i aria-hidden="true" class="file excel outline icon"></i>
                                            <i aria-hidden="true" class="download corner icon"></i>
                                        </i>`,
                                title: t('home.download_all_datas'),
                                class: 'custom-icon',
                                click: downloadHourlyData.mutate,
                            }],
                        }
                    },
                }: {toolbar:{ tools: {customIcons: []}}}),
                zoom: { enabled: false },
            },
            xaxis: {
                            categories: data.map(d => `${("00" + d.h).slice(-2)}h`)
                        },
                        legend: {
                            markers: {
                                fillColors: ['#45b29d', '#334d5c'],
                            }
                        },
                        stroke: {
                            colors: ['transparent', '#334d5c'],
                            width: [4, 3],
                        },
                        tooltip: {
                            shared: false,
                            intersect: true,
                            custom: function ({ series, seriesIndex, dataPointIndex, w }) {
                                return customTooltip({ series, seriesIndex, dataPointIndex, w, currencyCode: user.getCompanyCurrency(), locale: user.getCompanyLocale() });
                            }
                        },
                        colors: ['#45b29d', '#334d5c'],
                        yaxis: [
                            {
                                title: {
                                    text: t('home.revenues')
                                }
                            },
                            {
                                opposite: true,
                                title: {
                                    text: t('home.order_count')
                                },
                            }

                        ],
                        title: {
                            text: t('home.hourly_activity'),
                            align: 'center'
                        },
        }
    )


    return (
        <React.Fragment>
            <Segment style={{
                maxHeight: '300px'
            }}>
                <Chart
                    ref={chartRef}

                    options={computeChartOptions(!downloadHourlyData.isPending)}
                       
                    series={[{
                        name: t('home.revenues'),
                        data: data.map(d => unitFormat(d.revenue, user.getCompanyCurrency())),
                        dataType: 'CURRENCY',
                        type: 'bar'
                    }, {
                        name: t('home.order_count'),
                        data: data.map(d => d.nbr),
                        dataType: 'NUMERIC',
                        type: 'line'

                    }]}
                    type="line"
                    height={250}
                />

            </Segment>
        </React.Fragment>
    )
}

export default HourChart
